import { render, staticRenderFns } from "./ParticipantAdd.vue?vue&type=template&id=57271270&"
import script from "./ParticipantAdd.vue?vue&type=script&lang=js&"
export * from "./ParticipantAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports